import { useQueries } from '@tanstack/react-query';
import { creatorbaseQueries, tiktokQueries } from '@round/api';

const audioOptions = creatorbaseQueries.tiktokAudio.options.detail;
const audioAssetOptions = tiktokQueries.audioAsset.options.detail;
const audioUtils = creatorbaseQueries.tiktokAudio.utils;

export default function useAudioData(audioId: number | undefined | null) {
    const results = useQueries({
        queries: [audioOptions(audioId), audioAssetOptions(audioId)],
    });

    return { results, helpers: { audio: audioUtils.detail } };
}
